import type { ToolFinderAnswers } from './toolFinder';

const TOOL_FINDER_STORAGE_PREFIX = 'disgenet-tools-finder-recommendation';
export const TOOL_FINDER_ANONYMOUS_USER_ID = 'anonymous';

export type StoredToolFinderRecommendation = {
  version: 1;
  userId: string;
  savedAt: string;
  answers: ToolFinderAnswers;
  toolIds: string[];
  summary: string;
  whyById: Record<string, string>;
  source: 'aida' | 'local';
  aidaRawPreview?: string | null;
  error?: string | null;
};

export function resolveToolFinderUserId(userSub?: string | null): string {
  return userSub?.trim() || TOOL_FINDER_ANONYMOUS_USER_ID;
}

function storageKeyForUser(userId: string): string {
  return `${TOOL_FINDER_STORAGE_PREFIX}:${userId}`;
}

export function readStoredToolFinderRecommendation(userId: string): StoredToolFinderRecommendation | null {
  if (typeof window === 'undefined') return null;

  try {
    const raw = window.localStorage.getItem(storageKeyForUser(userId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredToolFinderRecommendation;
    if (parsed?.version !== 1 || !Array.isArray(parsed.toolIds)) return null;
    if (parsed.userId && parsed.userId !== userId) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeStoredToolFinderRecommendation(
  userId: string,
  value: Omit<StoredToolFinderRecommendation, 'userId'> & { userId?: string },
): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(storageKeyForUser(userId), JSON.stringify({ ...value, userId }));
}

export function clearStoredToolFinderRecommendation(userId: string): void {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(storageKeyForUser(userId));
}
